import { IMAGE_INFO_ENDPOINT } from '@yme/common/endpoints';
import { Network } from '@yme/services/network';
import { getData } from './getData';
export const getPartnerDetailsData = async (endpoint) => {
    return await getData(endpoint).then(async (response) => {
        const data = response.data.partnerByPath.item;
        const imageResponse = await Network.post(IMAGE_INFO_ENDPOINT, [data.partnerLogo?._path]);
        const partnerLogo = imageResponse.data[data.partnerLogo?._path];
        return {
            ...data,
            partnerLogo,
        };
    });
};
